export default __webpack_public_path__ + "static/media/imageColorization2.3cc45b6f.png";